import React, { ReactNode } from "react";
import { CircularProgress, Stack, Typography } from "@mui/material";
import { CloudDone, CloudOff } from "@mui/icons-material";
import { DraftSaveState } from "../../hooks/useDraftAutosave";
import { translate } from "../../services/Translations/translatorService";
import draftAutosaveIndicatorStyles from "./draftAutosaveIndicatorStyles";

type SaveStateConfig = {
  icon: ReactNode;
  label: string;
  color: string;
};

const saveStateConfigs: Record<Exclude<DraftSaveState, "idle">, SaveStateConfig> = {
  saving: { icon: <CircularProgress size={16} color={"inherit"} />, label: translate("saveStates.saving"), color: "text.secondary" },
  saved: { icon: <CloudDone fontSize={"small"} />, label: translate("saveStates.saved"), color: "success.main" },
  error: { icon: <CloudOff fontSize={"small"} />, label: translate("saveStates.error"), color: "error.main" },
};

type DraftAutosaveIndicatorProps = {
  saveState: DraftSaveState;
};

export default function DraftAutosaveIndicator({ saveState }: DraftAutosaveIndicatorProps) {
  if (saveState === "idle") {
    return <Stack sx={draftAutosaveIndicatorStyles.root} />;
  }

  const { icon, label, color } = saveStateConfigs[saveState];

  return (
    <Stack direction={"row"} spacing={0.5} sx={{ ...draftAutosaveIndicatorStyles.root, color }}>
      {icon}
      <Typography variant={"caption"} sx={{ whiteSpace: "nowrap" }}>
        {label}
      </Typography>
    </Stack>
  );
}
